import { endpointsList } from '@/helpers';
import axios from 'axios';
import {
  IFieldMapping,
  IGetContentTypeAndCheckBotMappingDto,
  ProjectType,
} from 'types';
import { ref } from 'vue';

export function useGetContentTypeMapping(
  projectType: ProjectType,
  contentTypeId: string,
  projectId: string,
  supplierId?: string,
) {
  const contentTypeMapping = ref<IFieldMapping[]>([]);

  async function getContentTypeMapping() {
    if (projectType === ProjectType.SUPPLIER_PROJECT) {
      if (!supplierId) throw new Error('No supplierId provided');
      const response = await axios.get<IFieldMapping[]>(
        endpointsList.contentTypeMappings.getFieldsMapping(
          contentTypeId,
          projectId,
          supplierId,
        ),
      );
      contentTypeMapping.value = response.data;
    } else if (projectType === ProjectType.DIGITALIZATION_PROJECT) {
      const response = await axios.get<IGetContentTypeAndCheckBotMappingDto>(
        endpointsList.contentTypeMappings.getDigitalizationContentTypeAndCheckBotMapping(
          contentTypeId,
          projectId,
        ),
      );
      contentTypeMapping.value = response.data.fieldMappings;
    }
  }

  return {
    contentTypeMapping,
    getContentTypeMapping,
  };
}
